// https://vuex.vuejs.org/en/getters.html

export default {
  accounts(state) {
    return state.accounts;
  },
  account(state) {
    return state.account;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  loaded(state) {
    return state.loaded;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
